import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aum_in_base_currency: {
    name: 'AUM in the base currency of the fund (calculated as set out in Article 2 of the AIFMD Level 2 Regulation)',
    order: 28,
    letter: 'A'
  },
  total_net_asset_value: {
    name: 'Total net asset value in the base currency of the fund',
    order: 29,
    letter: 'A'
  },
  base_currency: {
    name: 'Base currency',
    order: 30,
    letter: 'A'
  },
  fx_eur_rate: { name: 'EURO FX rate', order: 31, letter: 'A' },
  fx_eur_reference_rate_type: {
    name: 'Type of FX reference rate used',
    order: 32,
    letter: 'A'
  },
  fx_eur_other_reference_rate_description: {
    name: 'Source of a EURO reference rate not published by the ECB',
    order: 33,
    letter: 'A'
  }
};

export function BaseCurrency({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.BASE_CURRENCY_INFORMATION,
    onChangeFund,
    schema: schema.BASE_CURRENCY_INFORMATION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.BASE_CURRENCY_INFORMATION?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'BASE_CURRENCY_INFORMATION',
    columnLables
  });

  return (
    <Table
      id="fca-reporttables-base-currency-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
